import Vue from 'vue'
import Router from 'vue-router'
import onlineOfficeViewer from "@/components/onlineOfficeViewer.vue";
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    // 在线预览
    {
      path: '/onlineOfficeViewer',
      name: '在线预览',
      id: '0-1',
      appear: false,
      meta: {
        hideHeader: true,
        hideFooter: true,
      },
      component: onlineOfficeViewer
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/index.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/login.vue')
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      meta: { isBule: true },
      component: () => import('@/components/sign-up.vue')
    },
    {
      path: '/join',
      meta: { isBule: true },
      component: () => import('@/components/join-us.vue')
    },
    {
      path: '/exchange',
      name: 'exchange',
      meta: { isBule: true },
      component: () => import('@/components/certification/exchange.vue')
    },
    {
      path: '/me',
      meta: { isBule: true },
      component: () => import('@/components/certification/me.vue')
    },
    {
      path: '/member',
      meta: { isBule: true },
      component: () => import('@/components/certification/member.vue')
    },
    {
      path: '/order',
      meta: { isBule: true },
      component: () => import('@/components/order/index.vue')
    },
    {
      path: '/product',
      component: () => import('@/components/product.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth'
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
